import { getAxiosClient } from "../../axios-client";
import { StorageAreaAvailabilityGetByIdRequestBody, StorageAreaAvailabilityGetByIdResponse } from "./types";

const axiosClient = getAxiosClient();
export const StorageAreaAvailabilityGetById = async (body: StorageAreaAvailabilityGetByIdRequestBody) => {
  return await axiosClient.ax.post<StorageAreaAvailabilityGetByIdResponse>(
    "Warehouses/StorageAreaAvailabilityGetById",
    body
  );
};
